var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{attrs:{"options":_vm.dropzoneOptions,"id":"dropzone"},on:{"vdropzone-removed-file":_vm.onDelete,"vdropzone-success":_vm.onLoad,"vdropzone-error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }